export default __webpack_public_path__ + "static/media/BlueCar.bea776f9.jpg";